import { render } from "./RoleCreate.vue?vue&type=template&id=1cf835f4&ts=true"
import script from "./RoleCreate.vue?vue&type=script&lang=ts"
export * from "./RoleCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__